import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../teal-react/utils/token';

export default function SignOut() {
  const navigate = useNavigate();
  const { setToken } = useAuth();
  useEffect(() => {
    setToken(null);
    navigate('/auth');
    // eslint-disable-next-line
  }, []);
  return null;
}
